import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LINE_OF_BUSINESS_ENUM } from '@ptl/account-management';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { Doctor as DoctorKyruus } from '../doctor-information-kyruus/configs/interfaces/doctors.interface';
import { Doctor as DoctorSapphireDigital } from '../doctor-information-sapphire-digital/configs/interfaces/doctors.interface';
import { DOCTOR_VENDOR_TYPE } from './configs/enums/doctor-vendor-type.enum';

import { DoctorVendorTypeState, DOCTOR_VENDOR_TYPE_STATE_REDUX_ID } from './configs/reducers/doctor-information.reducer';

@Component({
    selector: 'app-doctor-information',
    templateUrl: './doctor-information.component.html',
    styleUrls: ['./doctor-information.component.scss'],
    standalone: false
})
export class DoctorInformationComponent implements OnInit {

  @Input() title = 'Find Doctors';
  @Input() subTitle;
  @Input() description;
  @Input() primaryCareProviderOnly = false;
  @Input() nextButtonLabel: string;
  @Input() nextButtonUrl: string;
  @Input() backButtonLabel: string;
  @Input() backButtonUrl: string;
  @Input() market: "INDIVIDUAL" | "SENIOR";
  marketAsLOBEnum: LINE_OF_BUSINESS_ENUM;
  @Input() defaultRadius: string;

  // If set to true will include branded network id in provider search
  @Input() useBrandNetwork: string;
  useBrandNetworkBool: boolean = false;

  /** CHECK THAT THIS IS WORKING */
  @Output() doctorsChanged = new EventEmitter<DoctorSapphireDigital[] | DoctorKyruus[]>();

  vendorType: DOCTOR_VENDOR_TYPE;

  constructor(
    private reducerUtilityService: ReducerUtilityService
  ) {
  }

  ngOnInit() {
    const doctorVendorState: DoctorVendorTypeState = this.reducerUtilityService.getState(DOCTOR_VENDOR_TYPE_STATE_REDUX_ID);
    this.vendorType = doctorVendorState.vendorType;
  }


}
